import { createFileRoute } from "@tanstack/react-router";
import { Zustellungen } from "@/pages/team/Zustellungen";

export const Route = createFileRoute("/_angemeldet/_mitarbeiter/zustellungen")({
	component: Zustellungen,
});
